export default __webpack_public_path__ + "static/media/login.dcb64d25.png";